import { App } from 'vue';
import Clarity from '@microsoft/clarity';
import { Store } from 'vuex';

interface ClarityConsent {
    ad_Storage?: 'granted' | 'denied';
    analytics_Storage?: 'granted' | 'denied';
}

interface ClarityPluginOptions {
    projectId: string;
    store?: Store<any>;
    consent?: ClarityConsent;
}

export default {
    install(app: App, options: ClarityPluginOptions) {
        const { projectId, store, consent } = options;

        if (!projectId) {
            console.error('Microsoft Clarity project ID is required.');
            return;
        }

        Clarity.init(projectId);

        if (consent && typeof window !== 'undefined' && (window as any).clarity) {
            (window as any).clarity('consentv2', consent);
        }

        const identifyUser = (userId: string | number | null | undefined) => {
            if (userId) {
                Clarity.identify(String(userId));
            }
        };

        app.config.globalProperties.$clarity = {
            identify: identifyUser,
            setConsent: (consentOptions: ClarityConsent) => {
                if (typeof window !== 'undefined' && (window as any).clarity) {
                    (window as any).clarity('consentv2', consentOptions);
                }
            }
        };

        if (store) {
            store.watch(
                (state) => state.auth?.user?.id,
                (userId) => {
                    if (userId) {
                        identifyUser(userId);
                    }
                }
            );

            const initialUserId = store.getters['auth/getUserId'];
            if (initialUserId) {
                identifyUser(initialUserId);
            }
        }
    }
};

